/**
 * Global axios response interceptor: when any API returns response.data.statuscode === 403,
 * dispatch SET_LOGOUT_PROVISION so the app shows the "You have been logged out" popup
 * (same as company and other APIs).
 */
import axios from "axios";
import store from "../redux/store";
import { SET_LOGOUT_PROVISION } from "../actions/types";

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.statuscode === 403) {
      store.dispatch({ type: SET_LOGOUT_PROVISION });
      return Promise.reject(response);
    }
    return response;
  },
  (error) => Promise.reject(error)
);
